import { groupNavLinks } from './group-nav-links'
import { useNextRouter } from 'app/hooks/use-next-router'
import { Container, DropdownItemProps, DropdownMenu, XStack, shadowStandard } from '@my/ui'
import { NavCarousel, SecondaryNavigation } from 'app/components'
import { useState } from 'react'

const dropdownItems = [
  {
    label: 'Chats',
    href: '/groups/feed',
  },
  {
    label: 'Discounts',
    href: '/student-discount',
  },
  {
    label: 'Life',
    href: '/life',
  },
  {
    label: 'Freshers',
    href: '/freshers',
  },
]

export type GroupNavCarouselProps = {}

export const GroupNavCarousel = ({}: GroupNavCarouselProps) => {
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false)
  const { pathname } = useNextRouter()

  const currentSelectedItem =
    groupNavLinks.find((item) => pathname.includes(item.href)) || groupNavLinks[0]

  return (
    <SecondaryNavigation>
      <Container size="sm" zIndex="$2" fd="row" ai="center" py="$2.5" gutter>
        <DropdownMenu
          open={dropdownMenuOpen}
          onOpenChange={setDropdownMenuOpen}
          initialItem={dropdownItems[0] as DropdownItemProps}
          items={dropdownItems}
          itemProps={{
            h: 40,
          }}
          contentProps={{
            top: -40,
            $gtSm: {
              display: 'none',
            },
          }}
          triggerProps={{
            h: 40,
            mr: '$2',
            $gtSm: {
              display: 'none',
            },
          }}
        />
        <XStack flex={1} $sm={{ overflow: 'hidden' }}>
          <NavCarousel items={groupNavLinks} currentSelectedItem={currentSelectedItem} size="sm" />
        </XStack>
      </Container>
    </SecondaryNavigation>
  )
}
